<div class="autorizacao-manual-shell autorizacao-manual" [ngClass]="usuario?.retorno?.aparencia ?? 'PADRAO'">
  <app-title-box
    [local]="tituloLocal"
    [mostrarBotaoFiltrar]="true"
    (alternarFiltro)="alternarFiltro()"
  >
    <button mat-flat-button color="primary" type="button" (click)="onIncluir()">
      <mat-icon>add</mat-icon>
      Incluir
    </button>
    <button mat-stroked-button color="primary" type="button" (click)="onExcel()">
      <mat-icon>description</mat-icon>
      Excel
    </button>
  </app-title-box>

  <app-flash-message></app-flash-message>

  <app-filter-box
    [aberto]="filtroAberto"
    (abertoChange)="filtroAberto = $event"
    (aplicarFiltro)="aplicarFiltroServidor()"
  >
    <div class="autorizacao-manual__filtro-wrap">
      <div class="autorizacao-manual__filtros autorizacao-manual__filtros--grid">
        <mat-form-field class="autorizacao-manual__campo" appearance="outline">
          <mat-label>Data de criação (de)</mat-label>
          <input
            matInput
            type="date"
            [(ngModel)]="filtros.dataInicio"
            name="fsDataInicio"
          />
          <button
            *ngIf="filtros.dataInicio"
            mat-icon-button
            matSuffix
            type="button"
            (click)="limparFiltroDataInicio()"
            matTooltip="Limpar data"
            aria-label="Limpar data de criação inicial"
          >
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        <mat-form-field class="autorizacao-manual__campo" appearance="outline">
          <mat-label>Data de criação (até)</mat-label>
          <input
            matInput
            type="date"
            [(ngModel)]="filtros.dataCriacaoAte"
            name="fsDataCriacaoAte"
          />
          <button
            *ngIf="filtros.dataCriacaoAte"
            mat-icon-button
            matSuffix
            type="button"
            (click)="limparFiltroDataCriacaoAte()"
            matTooltip="Limpar data"
            aria-label="Limpar data de criação final"
          >
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        <mat-form-field class="autorizacao-manual__campo" appearance="outline">
          <mat-label>Motorista</mat-label>
          <input
            matInput
            [(ngModel)]="filtros.motoristaApelido"
            placeholder="Clique na lupa para buscar"
            autocomplete="off"
            name="fsMot"
            readonly
          />
          <button
            mat-icon-button
            matSuffix
            type="button"
            (click)="abrirBuscaMotorista()"
            matTooltip="Buscar motorista"
          >
            <mat-icon>search</mat-icon>
          </button>
          <button
            *ngIf="filtros.motoristaApelido"
            mat-icon-button
            matSuffix
            type="button"
            (click)="limparMotorista()"
            matTooltip="Limpar motorista"
          >
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        <mat-form-field class="autorizacao-manual__campo" appearance="outline">
          <mat-label>Placa</mat-label>
          <input
            matInput
            [(ngModel)]="filtros.placa"
            placeholder="ABC1234"
            autocomplete="off"
            name="fsPlaca"
          />
          <button
            *ngIf="filtros.placa?.trim()"
            mat-icon-button
            matSuffix
            type="button"
            (click)="limparFiltroPlacaCampo()"
            matTooltip="Limpar placa"
            aria-label="Limpar placa do filtro"
          >
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>
      <div class="autorizacao-manual__filtros autorizacao-manual__filtros--radios-row">
        <div class="autorizacao-manual__radio-grupo">
          <span class="autorizacao-manual__rotulo">Autorizado</span>
          <mat-radio-group
            [(ngModel)]="filtros.autorizado"
            name="fsAut"
            class="autorizacao-manual__radios"
          >
            <mat-radio-button value="todos">Todos</mat-radio-button>
            <mat-radio-button value="sim">Sim</mat-radio-button>
            <mat-radio-button value="nao">Não</mat-radio-button>
          </mat-radio-group>
        </div>
        <div class="autorizacao-manual__radio-grupo">
          <span class="autorizacao-manual__rotulo">Abastecimento realizado</span>
          <mat-radio-group
            [(ngModel)]="filtros.abastecimento"
            name="fsAb"
            class="autorizacao-manual__radios"
          >
            <mat-radio-button value="todos">Todos</mat-radio-button>
            <mat-radio-button value="sim">Sim</mat-radio-button>
            <mat-radio-button value="nao">Não</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </div>
    <button
      filter-box-footer-extras
      mat-stroked-button
      type="button"
      (click)="limparFiltros()"
    >
      Limpar filtros
    </button>
  </app-filter-box>

  <section class="secao-lista autorizacao-manual__secao autorizacao-manual__conteudo">
    <!-- <div class="secao-cabecalho">
      <h2>Lista (todas as colunas — rolagem horizontal)</h2>
    </div> -->

    <div class="autorizacao-manual__lista-outer">
      <app-list-box
        #listBox
        [itens]="itens"
        [totalRegistros]="totalRegistros"
        [paginaAtual]="paginaAtual"
        [tamanhoPagina]="tamanhoPagina"
        [opcoesTamanhoPagina]="opcoesTamanhoPaginaLista"
        [colunas]="colunas"
        [acoesEngrenagem]="acoesEngrenagem"
        filtroTextoLabel="Filtrar nesta página"
        filtroTextoPlaceholder="Digite para filtrar linhas exibidas"
        [paginarColunas]="false"
        [ordenacaoServerSide]="true"
        (paginacaoAlterada)="onPaginacaoAlterada($event)"
        (botaoAcaoClicado)="onBotaoAcao($event)"
        (ordenacaoAlterada)="onOrdenacaoAlterada($event)"
        (exportarTodosSolicitado)="onExportarTodos($event)"
        (iconeImagemClicado)="onIconeImagemClicado($event)"
      >
      </app-list-box>
    </div>
  </section>
</div>
